<template>
  <div :class="['plate',mode]">
    <div class="title1">题材板块</div>

    <div class="plate_item">
      <p v-for="item in plate_list" :key="item.id" @click="goDetail(item)">
        <span>{{item.theme}}</span> 
        <i 
          :class="[
            item.chg_pct > 0 ? 'red' : '',
            item.chg_pct < 0 ? 'green' : '',
        ]">
          {{parseFloat(item.chg_pct).toFixed(2)}}%
        </i>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    plate_list:{
      type:Array,
      default:[],
    }
  },
  data(){
        return{
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070
        }
    },
    created() {
        console.log(this.$route.params);
    },
    methods:{
        // 跳转详情页
        goDetail(item) {
          //this.$goAppLink('theme',`&jump_id=${item.id}`);
          this.$srH5CallNativeMethodApp('theme',{
              jump_id: item.id,
          })
          
        },
    }
}

</script>
<style lang="scss" scoped>
  @import "~@/assets/sass/globalapp.scss";
  .plate{
    padding: rem2(15px) rem2(12px);
    border-bottom: rem2(1px) solid #EBEBEB;
    .plate_item{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      
        >p{
          width: 43%;
          display: flex;
          padding: rem2(5px)  rem2(8px);
          justify-content: space-between;
          align-items: center;
          flex-shrink: 0;
          margin-top: rem2(10px);
          border-radius: rem2(2px);
          background: #F3F6FD;
          font-size: rem2(13px);

          >span{
            overflow: hidden;
            text-overflow: ellipsis;
          }

          >i{
            font-style: normal;
          }
        }
    }
  }

  .light_mode{

  }

  .dark_mode{
    .plate{
      border-bottom-color: #121212;//
      .plate_item{
        >p{
          background: #1E1E1E;
        }
      }
    }
  }
</style>